import React, { useContext, useState } from "react"
import { Box, IconButton, Switch, Typography } from "@mui/material"
import useStyles from "./TrackingClasses"
import { styled } from "@mui/material/styles";
import LeftCalendarIcon from "../../assets/images/icon/LeftCalendarIcon"
import RightCalendarIcon from "../../assets/images/icon/RightCalendarIcon"
import { TrackingContext } from "../../context/userTracking"
import moment from "moment"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { pxToRem } from "../../theme/typography"
import { ArrowUpNew } from "../../assets/images/icon/ArrowDownGreenNew"
import Calendar from "../../assets/images/icon/Calendar"
import dayjs from "dayjs"
import clsx from "clsx"
import CommonTypo from "../../components/CommonTypo"
// import { IOSSwitch } from "../reflective-questions/leftSideRefQueNew"
import { UserTypeContext } from "../../context/userStatus"
import { isExpandMode } from "../../store/actions/userTypeAction"
import { trackingService } from "../../services/tracking"
interface switchProps {
    onChange: any;
    checked: boolean;
}
const IOSSwitch = styled((props: switchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 48,
    height: 24,
    padding: 0,
    "& .MuiSwitch-switchBase": {
        padding: 0,
        position: "absolute !important",
        // margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
            transform: "translateX(24px)",
            color: "var(--color-border)",
            "& + .MuiSwitch-track": {
                backgroundColor:
                    theme.palette.mode === "dark" ? "#2ECA45" : "var(--color-new-main)",
                opacity: 1,
                border: 0,
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.5,
            },
            "& .MuiSwitch-thumb": {
                boxSizing: "border-box",
                width: 16,
                height: 16,
                backgroundColor: "var(--white-background)",
                margin: "4px",
            },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
            color: "var(--color-border)",
            border: "6px solid var(--color-border)",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
            color:
                theme.palette.mode === "light"
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        "&.Mui-disabled + .MuiSwitch-track": {
            opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
        },
    },
    "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 16,
        height: 16,
        backgroundColor: "var(--white-background)",
        margin: "4px",
    },
    "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor:
            theme.palette.mode === "light" ? "var(--color-border)" : "#39393D",
        border: `1px solid var(--color-border)`,
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
            duration: 500,
        }),
    },
}));
const CurrentDateTitle = ({
    nextMonth,
    prevMonth,
    onSelectCustomDate
}) => {
    const { state: ITrackerState, dispatch: trackingDispatch } =
        useContext(TrackingContext);
    const { state: IUserState } =
        useContext(UserTypeContext);
    const [endDate, setEndDate] = useState(dayjs())
    const [popupvisible, setpopupvisible] = useState(false)
    const {
        startDate,
        calendar,
        isExpandable
    } = ITrackerState
    const { state: IUserTypeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    const classes = useStyles()
    let addHeight = 0
    let userValues = JSON.parse(localStorage.getItem("userValues"));
    const foundElement = document.getElementById("track-quote")
    if (foundElement) {
        const rect = foundElement.getBoundingClientRect();
        if (rect.height) {
            addHeight = rect.height - 10
        }
    }
    const commonCSS = {
        "& .MuiPickersFadeTransitionGroup-root": {
            color: "var(--datepicker-muted-text)",
            // fontFamily: "Poppins",
            // fontSize: `${pxToRem(10)} !important`,
            fontSize: `${pxToRem(16)} !important`,
            lineHeight: `${pxToRem(31.2)} !important`,
            // textAlign: "center !important",
            fontWeight: `400 !important`,
            "&.MuiTypography-root": {
                "@media  (max-width: 600px) and (min-width: 100px)": {
                    fontSize: `${pxToRem(16)} !important`,
                    lineHeight: `${pxToRem(31.2)} !important`
                },
            }
        },
        "& .Mui-selected": {
            backgroundColor: "var(--color-new-main) !important",
            "&:hover": {
                backgroundColor: "var(--color-new-main) !important",
            },
            "&:focus": {
                backgroundColor: "var(--color-new-main) !important",
            }
        },
        "& .MuiSvgIcon-root": {
            "path": {
                fill: "var(--color-new-main)"
            }
        },
        "& .MuiPickersCalendarHeader-labelContainer": {
            "& .MuiPickersCalendarHeader-label": {
                lineHeight: "30px"
            }
        },
        "& .MuiPickersCalendarHeader-switchViewButton": {
            "& svg": {
                "& path": {
                    fill: "var(--color-black) !important",
                    color: "var(--color-black) !important",
                }
            }
        },
        "& .MuiPickersCalendarHeader-label": {
            color: "var(--color-black) !important"
        },
        "& .PrivatePickersSlideTransition-root": {
            minHeight: "155px",
            "& .MuiYearPicker-root": {
                "& .PrivatePickersYear-root": {
                    "& .PrivatePickersYear-button": {
                        backgroundColor: "var(--color-new-main) !important"
                    },
                },
            },
        },
        "& .MuiPickersArrowSwitcher-spacer": {
            width: "6px"
        },
        "& .MuiDayPicker-header": {
            "span": {
                color: "var(--datepicker-muted-text)"
            }
        },
        "& .MuiDayPicker-monthContainer": {
            "& .MuiButtonBase-root": {
                color: "var(--datepicker-cell-text)",
                "&.Mui-selected": {
                    backgroundColor: "var(--color-new-main)",
                    color: "var(--button-active-text)"
                }
            }
        },
        "& .MuiPickersDay-today": {
            border: "1px solid var(--color-new-main)"
        }
    }
    const {
        userDetails: {
            createdAt = ""
        }
    } = IUserState
    const minSelectableDate = dayjs(createdAt); // Set your minimum date
    const maxSelectableDate = dayjs().endOf("month"); // Restrict selection to the current month
    const handleExpandClick = () => {
        const obj = {
            mixpanel_type: "EXTENDED_CLICK",
        };
        trackingService.signupCompletedBoarding(IUserTypeState.token, obj);
    };
    const handleClick = (
        event: React.MouseEvent<HTMLElement>,
        expand = false
    ) => {
        localStorage.setItem("viewType", expand ? "expand" : "default");
        userTypeDispatch(isExpandMode(expand));
        if (expand) {
            handleExpandClick();
        }
    };
    const searchBarProps = {
        // make sure all required component's inputs/Props keys&types match
        onChange: (e) => {
            handleClick(e, !IUserTypeState?.isExpand)
        },
        checked: IUserTypeState?.isExpand,
    };
    return foundElement && <Box
        display="flex"
        alignItems="center"
        position={"relative"}
        height={"70px"}
        sx={{
            justifyContent: "space-between",
            background: "var(--white-background)",
            width: "100%",
            // padding: "60px 24px 27px 0",
            position: "sticky",
            top: "0px",
            alignSelf: "flex-start",
            zIndex: "100",
        }}>



        <Box
            display="flex"
            alignItems="center"
            position={"fixed"}
            // height={"100%"}
            // top={`${120 + addHeight}px`}
            justifyContent={"space-between"}
            width={isExpandable ? "66%" : "calc(58% - 25px)"}
            paddingRight={"40px"}
        >
            <LocalizationProvider dateAdapter={AdapterDayjs} >

                <Box display={"flex"} alignItems={"center"} gap={"8px"}  width={"100%"} sx={{
                    position: "fixed",
                    left: `calc(220px + 30vw + ${isExpandable ? "" : "0px"})`,
                    top: IUserTypeState.restrictUser ? '55px' : '45px',
                    transform: `translateY(calc(100% + ${IUserTypeState.restrictUser ? "64px" : "45px"}))`
                }}>

                    <IconButton
                        className={classes.iconButtonCalender}
                        onClick={() => {
                            prevMonth()
                        }}
                        disabled={
                            !moment(userValues?.createdAt).isBefore(moment(startDate))
                        }
                    >
                        <LeftCalendarIcon size="24" color="var(--color-text-secondary)"/>
                    </IconButton>

                    <DatePicker
                        value={endDate}
                        openTo="month"
                        onChange={(newValue) => {
                            setpopupvisible(!popupvisible)
                            setTimeout(() => {
                                setEndDate(newValue)
                                onSelectCustomDate(newValue)
                            }, 10);

                        }}
                        PopperProps={{
                            anchorEl: document.getElementById("datePickerAnchor"),
                            sx: {
                                ...commonCSS
                            },
                        }}
                        reduceAnimations={true}
                        open={popupvisible}
                        onOpen={() => setpopupvisible(!popupvisible)}
                        onClose={() => setpopupvisible(!popupvisible)}
                        minDate={minSelectableDate}  // Set minimum selectable date
                        maxDate={maxSelectableDate}
                        components={{
                            SwitchViewButton: (buttonProps) => (
                                <IconButton {...buttonProps}>
                                    <ArrowUpNew /> {/* Custom icon */}
                                </IconButton>
                            ),
                        }}
                        views={["year", "month"]}
                        inputFormat="MMM YYYY"
                        renderInput={(params) => {
                            return <Typography
                                variant="h2"
                                id="datePickerAnchor"
                                component="h2"
                                className={classes.monthTitle}
                                onClick={() => setpopupvisible(!popupvisible)}
                                
                            >
                                {calendar[0] && calendar[0][0] && calendar[0][0].format("MMMM")}
                            </Typography>
                        }}
                    />
                    <IconButton
                        className={classes.iconButtonCalender}
                        onClick={() => {
                            nextMonth()
                        }}
                    >
                        <RightCalendarIcon size="24" color="var(--color-text-secondary)"/>
                    </IconButton>
                </Box>
            </LocalizationProvider>

            <div className={classes.monthControls}>

                <Box display={"flex"} className={"expand-view-controls"} gap={"8px"} justifyContent={"flex-end"} alignItems={"center"} sx={{
                    position: "fixed",
                    right: "10px",
                    top: `${IUserTypeState.restrictUser ? "69px" : "55px"}`,
                    transform: `translateY(calc(100% + ${IUserTypeState.restrictUser ? "64px" : "50px"}))`
                }}>
                    <CommonTypo size={18} lineHeight={22} color="var(--color-text-primary)">Expand view</CommonTypo>
                    <IOSSwitch {...searchBarProps} />

                </Box>

            </div>
        </Box>
    </Box >
}

export default CurrentDateTitle